export function data() {
  return {
    formData: {
      garageID: 0,
      garageNumber: '',
      vehicleCapacity: 0,
      squareFeet: 0,
      unitID: 0
    },
    isDebug: true,
    isOpen: false,
    loading: true,
    isFetching: false,
    openOnFocus: true,
    addressData: [],
    addressDropDownList: [],
    addressFilterQuery: null,
    buttonText: 'Add'
  }
}
